export default [
  {
    path: '/topicSettings/ad',
    meta: {},
    component: () =>
      import(/* webpackChunkName: 'picLive' */ '@/pages/topicSettings/Ad.vue')
  },
  {
    path: '/topicSettings/customerService',
    meta: {},
    component: () =>
      import(
        /* webpackChunkName: 'sop' */ '@/pages/topicSettings/CustomerService.vue'
      )
  }
]
